import { z } from 'zod';
import { MetricDefinitionWhiteLabeling } from 'libs/end-to-end/src/types/databases/metrics/metric-definition';
import { MetricDefinitionCalibrationFraming } from 'libs/end-to-end/src/types/databases/metrics/metric-definition-calibration-framing';
import { MyMetricStaticControlVariableDefinition } from 'libs/end-to-end/src/my-metric-static-control-variable-definition';
import { NumericDisplayUnit } from 'libs/end-to-end/src/metrics';

// This is a similar type to `MetricDefinition`, but it also includes the `isMetricBoolean` field and `hasBiasTestTasks` flag.
export const MyMetricDefinition = z.object({
  columnHeaderValue: z.string(),
  displayName: z.string(),
  isPreferred: z.boolean(),
  calibrationFraming: MetricDefinitionCalibrationFraming,
  skillFraming: MetricDefinitionCalibrationFraming,
  whiteLabeling: MetricDefinitionWhiteLabeling,
  isMetricBoolean: z.boolean(),
  staticControlVariableDefinitions: z.array(
    MyMetricStaticControlVariableDefinition,
  ),
  hasBiasTestTasks: z.boolean(),
  description: z.string(),
  unit: NumericDisplayUnit.optional(),
});

export type MyMetricDefinition = z.infer<typeof MyMetricDefinition>;
